import Store from "@/store";
import clear_all_videos from "@/router/modules/methods/clear_all_videos";

export default {
    path: '/add-text',
    name: 'Add-Text',
    component: () => import('@/views/add_text/index.vue'),
    meta: {
        title: 'Добавление текста',
        forVisitors: true
    },
    beforeEnter: async (to, from, next) => {
        await clear_all_videos()
        if(Store.getters['entry_video/entry'].length === 0) {
            next({name: 'Theme'})
        } else {
            next()
        }
    }
}